export default class QualitySealPopupTracker {

    /**
     * @param element
     */
    constructor(element, w) {
        this.window = w || window;
        this.$element = $(element);
        this.$tracker = this.$element.data('quality-seal-popup-tracker');
        this.$trackerCode = this.$element.data('quality-seal-popup-tracker-code');
        this.setup();
    }

    setup() {
        this.$element.off('click').on('click', (event) => {
            $("#quality-seal-tracker").append(this.$trackerCode);
        });
    }

}
